var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBackupCar = function SvgBackupCar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#EC008C",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M9 4H6a2 2 0 0 0-2 2v3M22 4h3a2 2 0 0 1 2 2v3M9 28H6a2 2 0 0 1-2-2v-3M22 28h3a2 2 0 0 0 2-2v-3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EC008C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.879,
    d: "m7 12.289 2.558 2.131a.94.94 0 0 0 .601.218h10.595a.94.94 0 0 0 .602-.218l2.557-2.131M10.29 17.927h.01m10.326 0h.01M11.848 9h7.215a1.88 1.88 0 0 1 1.632.947l2.722 4.764a3.76 3.76 0 0 1 .495 1.865v5.579a.94.94 0 0 1-.94.94h-.939a.94.94 0 0 1-.94-.94v-.94H9.82v.94a.94.94 0 0 1-.94.94h-.94a.94.94 0 0 1-.939-.94v-5.58c0-.653.17-1.296.495-1.864l2.722-4.764A1.88 1.88 0 0 1 11.85 9m-1.09 8.927a.47.47 0 1 1-.94 0 .47.47 0 0 1 .94 0m10.336 0a.47.47 0 1 1-.94 0 .47.47 0 0 1 .94 0"
  })));
};
export default SvgBackupCar;